<template>
  <div class="card shadow-4 h-100">
    <div class="card-body">
      <h3 class="text-uppercase text-warning mb-5 pl-5">Bubble Meeting</h3>
      <p class="card-description mb-6">
        Choisissez notre outil <span class="text-warning">Bubble Meeting</span> pour organiser, préparer et animer vos réunions de façon efficace.
        <a href="https://bubblemeeting.net/organiser-une-reunion" target="_blank" class="text-primary">En savoir plus</a>
      </p>
      <!-- Card choosing -->
      <div class="border border-warning">
        <div class="card-body p-0">
          <h5 class="mx-3 text-warning border-bottom border-warning text-uppercase d-flex align-items-center justify-content-center" style="height: 4.5rem">Accès bubble meeting</h5>
          <div>
            <h4 class="text-center font-weight-bold text-dark mt-6" style="font-size: 1.5rem">
              {{ price }} € <span style="font-size: initial">HT / collaborateur</span>
            </h4>
            <p class="text-center text-muted mb-0">
              Facturé {{ currentPlan.period == 'mensuel' ? 'mensuellement' : 'annuellement' }}
            </p>
          </div>
          <form role="form" action="#" @submit.prevent="submitBubbleMeeting()">
            <div class="d-flex justify-content-center my-6">
              <input type="submit" value="Valider" class="btn btn-round btn-warning w-50 d-flex justify-content-center">
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- NOTIF SUCCESS -->
    <div id="meetingModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="meetingModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="meetingModalLabel" class="modal-title text-warning">Demande d'accès à Bubble Meeting</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div style="font-size: 2.5rem" class="text-success mx-auto d-flex justify-content-center"><i class="fas fa-check rotate-in-center"></i></div>
            <br><b>Votre demande d'accès à Bubble Meeting a bien été transmise</b>, nous reviendrons vers vous <b class="text-warning">pour vous informer de l'activation</b><br>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- END TEST NOTIF SUCCESS -->
  </div>
</template>

<style>
  .rotate-in-center {
    -webkit-animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: rotate-in-center 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  /**
  * ----------------------------------------
  * animation rotate-in-center
  * ----------------------------------------
  */
  @-webkit-keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
  }
  @keyframes rotate-in-center {
    0% {
      -webkit-transform: rotate(-360deg);
              transform: rotate(-360deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
      opacity: 1;
    }
  }
</style>

<script>
  import apiSrv from '../apiSrv';

  export default {
    props: {
      user: { type: Object, required: true },
      availablePlans: { type: Object, required: true },
    },
    data() {
      return {
        monthlyPrice: 10,
        yearlyPrice: 120,
      };
    },
    computed: {
      billingPlan() { return this.user.company && this.user.company.billing_plan; },
      currentPlan() { return this.availablePlans[this.billingPlan]; },
      price() {
        return this.currentPlan && this.currentPlan.period == 'mensuel' ? this.monthlyPrice : this.yearlyPrice;
      },
    },
    methods: {
      submitBubbleMeeting() {
        apiSrv.call(window.api.contactmail.url, 'POST', {
          name: "From myaccount premium page.",
          email: "unknown@bubbleplan.net",
          subject: "Bubble Meeting request",
          message: `L'utilisateur souhaite prendre Bubble Meeting pour ses collaborateurs`,
        }).then(() => {
          $('#meetingModal').modal('show');
        });
      },
    },
  };
</script>
